import React from 'react';
import TokenChips, { appendToken } from './TokenChips';
import Input from '../ui/Input';
import Textarea from '../ui/Textarea';
import EmailPreview from '../campaigns/EmailPreview';
import styles from './MessagingFields.module.css';

class EmailFields extends React.Component {
  render() {
    const { subject = '', html = '', onChange, showPreview = true } = this.props;
    return (
      <div className={showPreview ? styles.msgLayout : undefined}>
        <div className={styles.msgFields}>
          <div className={styles.fi}>
            <label className={styles.fiLabel}>Subject <span className={styles.req}>*</span></label>
            <Input value={subject} onChange={e => onChange('subject', e.target.value)} />
            <TokenChips onInsert={token => onChange('subject', appendToken(subject, token))} />
          </div>
          <div className={styles.fi}>
            <label className={styles.fiLabel}>Body (HTML) <span className={styles.req}>*</span></label>
            {/* style targets Textarea's outer wrap div, not the <textarea>
                itself — fontFamily still reaches it via CSS inheritance
                (Input.module.css's .input sets font-family: inherit), but
                height needs the real `rows` prop instead of a minHeight
                that would just pad empty wrapper space. */}
            <Textarea style={{ fontFamily: 'monospace' }} rows={8} value={html} onChange={e => onChange('html', e.target.value)} />
            <TokenChips onInsert={token => onChange('html', appendToken(html, token))} />
          </div>
        </div>
        {showPreview && <EmailPreview subject={subject} html={html} />}
      </div>
    );
  }
}

export default EmailFields;
